import script from "./CargarIndexarPDFs.vue?vue&type=script&setup=true&lang=js"
export * from "./CargarIndexarPDFs.vue?vue&type=script&setup=true&lang=js"

import "./CargarIndexarPDFs.vue?vue&type=style&index=0&id=fab99888&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fab99888"]])

export default __exports__